import styled from "styled-components"
export const Container = styled.div`
    padding:8px;
    background-color:#FAFCFA;
    border-radius: 4px;

`